// ===================================
// SENSILIGHT ICE V3 - REFINED CINEMATIC EXPERIENCE
// Faster cursor, word-reveal animations, scroll functions
// ===================================

// === SCOPE ICE STYLES TO THIS PAGE ===
// Only apply ice-v3-page body class on the dedicated legacy ICE landing page
if (document.querySelector('[data-ice-page]')) {
  document.body.classList.add('ice-v3-page');
}

// === BURGER MENU & MEGA MENU ===
const burgerMenu = document.querySelector('.burger-menu');
const megaMenuOverlay = document.querySelector('.mega-menu-overlay');
const megaMenuClose = document.querySelector('.mega-menu-close');
const megaMenuLinks = document.querySelectorAll('.mega-menu-link');

// Open mega menu when clicking burger
if (burgerMenu && megaMenuOverlay) {
    burgerMenu.addEventListener('click', () => {
        megaMenuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    });
}

// Close mega menu
if (megaMenuClose) {
    megaMenuClose.addEventListener('click', () => {
        megaMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
    });
}

// Close menu when clicking outside
if (megaMenuOverlay) {
    megaMenuOverlay.addEventListener('click', (e) => {
        if (e.target === megaMenuOverlay) {
            megaMenuOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
}

// Close menu when clicking a link
megaMenuLinks.forEach(link => {
    link.addEventListener('click', () => {
        megaMenuOverlay.classList.remove('active');
        document.body.style.overflow = '';
    });
});

// === CUSTOM CURSOR ===
const cursor = document.querySelector('.custom-cursor');
const cursorGlow = document.querySelector('.cursor-glow');

let mouseX = 0;
let mouseY = 0;
let cursorX = 0;
let cursorY = 0;
let glowX = 0;
let glowY = 0;

// Track mouse position
document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
});

// Smooth cursor follow animation - FASTER
function animateCursor() {
    if (!cursor || !cursorGlow) return;

    // Cursor follows quickly (increased from 0.2 to 0.35)
    cursorX += (mouseX - cursorX) * 0.35;
    cursorY += (mouseY - cursorY) * 0.35;

    // Glow follows moderately (increased from 0.08 to 0.18)
    glowX += (mouseX - glowX) * 0.18;
    glowY += (mouseY - glowY) * 0.18;

    cursor.style.transform = `translate(${cursorX}px, ${cursorY}px)`;
    cursorGlow.style.transform = `translate(${glowX - 150}px, ${glowY - 150}px)`;

    requestAnimationFrame(animateCursor);
}

if (cursor && cursorGlow) animateCursor();

// Cursor hover effects
if (cursor) {
    const hoverElements = document.querySelectorAll('a, button, .product-image, .flip-card');
    hoverElements.forEach(el => {
        el.addEventListener('mouseenter', () => {
            cursor.style.transform = `translate(${cursorX}px, ${cursorY}px) scale(2.5)`;
            cursor.style.borderColor = '#E8B4A0';
        });

        el.addEventListener('mouseleave', () => {
            cursor.style.transform = `translate(${cursorX}px, ${cursorY}px) scale(1)`;
            cursor.style.borderColor = '#D99B88';
        });
    });
}

// === VIDEO MANAGEMENT ===
const videos = document.querySelectorAll('.section-video, .hero-video');

// Lazy load videos based on viewport
const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const video = entry.target;

        if (entry.isIntersecting) {
            // Play video when in viewport
            if (video.paused) {
                video.play().catch(err => console.log('Video play prevented:', err));
            }
        } else {
            // Pause video when out of viewport for performance
            if (!video.paused) {
                video.pause();
            }
        }
    });
}, {
    threshold: 0.25
});

videos.forEach(video => {
    videoObserver.observe(video);

    // Ensure video loops
    video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.play();
    });
});

// === MULTI-LAYER PARALLAX ===
let scrollY = 0;
let ticking = false;

function updateParallax() {
    scrollY = window.pageYOffset;

    // Parallax on gradient orbs
    const orbs = document.querySelectorAll('.gradient-orb');
    orbs.forEach((orb, index) => {
        const speed = 0.2 + (index * 0.08);
        orb.style.transform = `translateY(${scrollY * speed}px)`;
    });

    // Parallax on section backgrounds
    const backgrounds = document.querySelectorAll('.section-background');
    backgrounds.forEach(bg => {
        const rect = bg.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            const offset = (window.innerHeight - rect.top) * 0.15;
            bg.style.transform = `translateY(${-offset}px)`;
        }
    });

    // Parallax on product image
    const productImage = document.querySelector('.product-image');
    if (productImage) {
        const rect = productImage.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            const offset = (window.innerHeight - rect.top) * 0.08;
            productImage.style.transform = `translateY(${-offset}px)`;
        }
    }

    // Parallax on floating graphic
    const floatingGraphic = document.querySelector('.floating-graphic');
    if (floatingGraphic) {
        const rect = floatingGraphic.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            const offset = (window.innerHeight - rect.top) * 0.12;
            floatingGraphic.style.transform = `translateY(${-offset}px) rotate(${offset * 0.05}deg)`;
        }
    }

    // Video zoom effect on scroll
    const heroVideo = document.querySelector('.hero-video');
    if (heroVideo) {
        const heroSection = document.querySelector('.hero');
        const heroRect = heroSection.getBoundingClientRect();
        const scrollProgress = Math.max(0, Math.min(1, -heroRect.top / window.innerHeight));
        const scale = 1.1 + (scrollProgress * 0.1);
        heroVideo.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }

    ticking = false;
}

function requestParallaxUpdate() {
    if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
    }
}

window.addEventListener('scroll', () => {
    if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
    }
});

// === SCROLL ANIMATIONS ===
const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
};

const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
        }
    });
}, observerOptions);

// Observe all animated elements
const animatedElements = document.querySelectorAll(`
    .showcase-content,
    .showcase-image,
    .history-headline,
    .history-text,
    .tech-header .section-badge,
    .tech-header .section-title,
    .tech-header .section-description,
    .benefits-header .section-badge,
    .benefits-header .section-title,
    .comparison-header .section-badge,
    .comparison-header .section-title,
    .cta-title,
    .cta-description,
    .cta-benefits,
    .cta-button.cta-large,
    .cta-note
`);

animatedElements.forEach(el => {
    if (el) animationObserver.observe(el);
});

// Stagger flip card animations
const flipCards = document.querySelectorAll('.flip-card');
flipCards.forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    card.style.transitionDelay = `${index * 0.15}s`;

    const cardObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    cardObserver.observe(card);
});

// === RESPONSIVE FLIP CARD TEXT ===
// Function to update flip card text based on screen width
function updateFlipCardText() {
    const isMobileDevice = window.innerWidth <= 1024;
    const flipHints = document.querySelectorAll('.flip-hint');

    if (isMobileDevice) {
        flipHints.forEach(hint => {
            hint.textContent = 'Tap for details';
        });

        // Add click handler for mobile flip cards (only once)
        const flipCards = document.querySelectorAll('.flip-card');
        flipCards.forEach(card => {
            if (!card.hasAttribute('data-click-handler')) {
                card.setAttribute('data-click-handler', 'true');
                let isFlipped = false;
                card.addEventListener('click', (e) => {
                    e.preventDefault();
                    const inner = card.querySelector('.flip-card-inner');
                    if (inner) {
                        isFlipped = !isFlipped;
                        if (isFlipped) {
                            inner.style.transform = 'rotateY(180deg)';
                        } else {
                            inner.style.transform = 'rotateY(0deg)';
                        }
                    }
                });
            }
        });
    } else {
        // Desktop - ensure text says "Hover for details"
        flipHints.forEach(hint => {
            hint.textContent = 'Hover for details';
        });
    }
}

// Run on page load
setTimeout(updateFlipCardText, 100);

// Update on window resize
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateFlipCardText, 100);
});

// === HEADER SCROLL EFFECT ===
const header = document.querySelector('.transparent-header');
let lastScroll = 0;

if (header) {
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        if (currentScroll > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        lastScroll = currentScroll;
    });
}

// === SMOOTH SCROLL FOR NAVIGATION ===
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;
        
        try {
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const header = document.querySelector('.header');
                const headerHeight = header ? header.offsetHeight : 0;
                
                const rect = target.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const targetPosition = rect.top + scrollTop - headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                
                // Update URL hash without jumping
                history.pushState(null, null, href);
            }
        } catch (err) {
            // Silently fail if href is not a valid selector
        }
    });
});

// === CTA BUTTON INTERACTIONS ===
const ctaButtons = document.querySelectorAll('.cta-button');
ctaButtons.forEach(button => {
    button.addEventListener('click', (e) => {
        // Create ripple effect
        const ripple = document.createElement('span');
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;

        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.classList.add('ripple');
        ripple.style.position = 'absolute';
        ripple.style.borderRadius = '50%';
        ripple.style.background = 'rgba(255, 255, 255, 0.5)';
        ripple.style.transform = 'scale(0)';
        ripple.style.animation = 'ripple 0.6s ease-out';

        button.style.position = 'relative';
        button.style.overflow = 'hidden';
        button.appendChild(ripple);

        setTimeout(() => ripple.remove(), 600);
    });
});

// Add ripple animation
const style = document.createElement('style');
style.textContent = `
    @keyframes ripple {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }
`;
document.head.appendChild(style);

// === COMPARISON CHART ===
// Use data from section template if available, otherwise use defaults
const comparisonData = window.comparisonData || {
    cooling: {
        title: 'Cooling System Comparison',
        devices: [
            { name: 'Sensilight ICE', value: 100, label: 'Integrated Cooling', isICE: true },
            { name: 'Braun Silk-expert Pro 5', value: 0, label: 'No Active Cooling', isICE: false },
            { name: 'Philips Lumea 9000', value: 0, label: 'No Active Cooling', isICE: false }
        ]
    },
    flashes: {
        title: 'Lifetime Flashes Comparison',
        devices: [
            { name: 'Sensilight ICE', value: 650000, label: '650,000', isICE: true },
            { name: 'Braun Silk-expert Pro 5', value: 400000, label: '400,000', isICE: false },
            { name: 'Philips Lumea 9000', value: 450000, label: '450,000', isICE: false }
        ]
    },
    window: {
        title: 'Treatment Window Area (cm²)',
        devices: [
            { name: 'Sensilight ICE', value: 4.3, label: '1.2-4.3 cm²', isICE: true },
            { name: 'Braun Silk-expert Pro 5', value: 4.0, label: '1.5-4.0 cm²', isICE: false },
            { name: 'Philips Lumea 9000', value: 4.1, label: '2.0-4.1 cm²', isICE: false }
        ]
    }
};

// Function to render vertical chart
function renderChart(feature) {
    const data = comparisonData[feature];
    const chartTitle = document.getElementById('chartTitle');
    const chartBars = document.getElementById('chartBars');

    if (!chartTitle || !chartBars || !data) return;

    chartTitle.textContent = data.title;
    const maxValue = Math.max(...data.devices.map(d => d.value));
    chartBars.innerHTML = '';

    data.devices.forEach((device, index) => {
        const barGroup = document.createElement('div');
        barGroup.className = 'bar-group-vertical';

        const barWrapper = document.createElement('div');
        barWrapper.className = 'bar-wrapper-vertical';

        const barFill = document.createElement('div');
        barFill.className = 'bar-fill-vertical';
        if (!device.isICE) barFill.classList.add('competitor');

        const percentage = maxValue > 0 ? (device.value / maxValue) * 100 : 0;
        const heightPx = Math.round((percentage / 100) * 350);

        // Format label based on alias, range, or single value
        const barValue = document.createElement('div');
        barValue.className = 'bar-value-vertical';
        const unit = data.unit || '';

        if (device.alias && device.alias.length > 0) {
            // Use display alias text when available (e.g. "Integrated Cooling", "None")
            barValue.textContent = device.alias;
        } else if (data.isRange && device.valueMin) {
            // Range display: "1.2–4.3 cm²"
            barValue.textContent = device.valueMin + '–' + device.value + (unit ? ' ' + unit : '');
        } else if (device.value === 0) {
            barValue.textContent = 'None';
        } else {
            // Single value: "650,000 flashes" or just "100"
            const formattedValue = device.value >= 1000
                ? device.value.toLocaleString()
                : device.value;
            barValue.textContent = formattedValue + (unit ? ' ' + unit : '');
        }

        barFill.style.height = '0px';
        barFill.appendChild(barValue);
        barWrapper.appendChild(barFill);

        const barLabel = document.createElement('div');
        barLabel.className = 'bar-label-vertical';
        barLabel.textContent = device.name;

        barGroup.appendChild(barWrapper);
        barGroup.appendChild(barLabel);
        chartBars.appendChild(barGroup);

        setTimeout(() => {
            barFill.style.height = heightPx + 'px';
        }, 150 * index);
    });
}

// Tab switching for chart
document.querySelectorAll('.comparison-tab').forEach(tab => {
    tab.addEventListener('click', () => {
        const feature = tab.getAttribute('data-feature');

        // Remove active class from all tabs
        document.querySelectorAll('.comparison-tab').forEach(t => t.classList.remove('active'));

        // Add active class to clicked tab
        tab.classList.add('active');

        // Scroll active tab into view on mobile
        scrollActiveTabIntoView(tab);

        // Render chart for selected feature
        renderChart(feature);
    });
});

// Scroll active tab into view on mobile
function scrollActiveTabIntoView(tab) {
    if (!tab) return;
    const container = tab.closest('.comparison-tabs');
    if (!container) return;
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
}

// Initialize with first tab
if (document.getElementById('chartBars')) {
    renderChart('depth');
}

// === PERFORMANCE OPTIMIZATION ===
// Reduce animations on low-performance devices
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('*').forEach(el => {
        el.style.animation = 'none';
        el.style.transition = 'none';
    });
}

// === LOADING OPTIMIZATION ===
window.addEventListener('load', () => {
    // Add loaded class to body for any load-dependent animations
    document.body.classList.add('loaded');

    // Preload critical videos
    const heroVideo = document.querySelector('.hero-video');
    if (heroVideo) {
        heroVideo.load();
    }
});

// === MOBILE TOUCH INTERACTIONS ===
if ('ontouchstart' in window) {
    // Disable custom cursor on touch devices
    if (cursor) cursor.style.display = 'none';
    if (cursorGlow) cursorGlow.style.display = 'none';

    // Add touch-friendly interactions
    const cards = document.querySelectorAll('.tech-card, .benefit-card');
    cards.forEach(card => {
        card.addEventListener('touchstart', () => {
            card.style.transform = 'scale(0.98)';
        });

        card.addEventListener('touchend', () => {
            card.style.transform = 'scale(1)';
        });
    });
}

// === INTERSECTION OBSERVER FOR STAGGERED ANIMATIONS ===
const staggerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
            setTimeout(() => {
                entry.target.classList.add('visible');
            }, index * 150); // Slower stagger for cinematic feel
        }
    });
}, observerOptions);

// Apply staggered animations to tech cards and benefit cards
document.querySelectorAll('.tech-card').forEach(card => staggerObserver.observe(card));
document.querySelectorAll('.benefit-card').forEach(card => staggerObserver.observe(card));

// === SCROLL PROGRESS INDICATOR ===
function updateScrollProgress() {
    const scrollProgress = (window.pageYOffset / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

    // Adjust hero video opacity based on scroll
    const heroVideo = document.querySelector('.hero-video');
    if (heroVideo) {
        const heroSection = document.querySelector('.hero');
        const heroRect = heroSection.getBoundingClientRect();
        const opacity = Math.max(0, Math.min(1, 1 - (Math.abs(heroRect.top) / window.innerHeight)));
        heroVideo.style.opacity = opacity * 0.6; // Max 60% opacity for cinematic feel
    }
}

window.addEventListener('scroll', updateScrollProgress);

// === VIDEO QUALITY ADJUSTMENT ===
// Reduce video quality on slower connections
if ('connection' in navigator) {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if (connection && connection.effectiveType) {
        // On slow connections, reduce video opacity further
        if (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g') {
            document.querySelectorAll('.section-video').forEach(video => {
                video.style.opacity = '0.2';
            });
        }
    }
}

// === WORD-BY-WORD REVEAL ANIMATION ===
const wordReveals = document.querySelectorAll('.word-reveal');
if (wordReveals.length > 0) {
    wordReveals.forEach((word, index) => {
        word.style.opacity = '0';
        word.style.transform = 'translateY(20px)';

        setTimeout(() => {
            word.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
            word.style.opacity = '1';
            word.style.transform = 'translateY(0)';
        }, 150 * index);
    });
}

// Animate CTA button
const ctaDiscover = document.querySelector('.cta-discover');
if (ctaDiscover) {
    setTimeout(() => {
        ctaDiscover.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        ctaDiscover.style.opacity = '1';
    }, 150 * wordReveals.length);
}

// Animate scroll indicator
const scrollIndicator = document.querySelector('.scroll-indicator.clickable');
if (scrollIndicator) {
    setTimeout(() => {
        scrollIndicator.style.transition = 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        scrollIndicator.style.opacity = '1';
    }, 150 * wordReveals.length + 300);
}

// === SCROLL FUNCTIONS ===
function scrollToComparison() {
    const comparison = document.getElementById('comparison');
    const headerHeight = document.querySelector('.header').offsetHeight;
    if (comparison) {
        window.scrollTo({
            top: comparison.offsetTop - headerHeight,
            behavior: 'smooth'
        });
    }
}

function scrollToNext() {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    // In Shopify, sections are wrapped in .shopify-section divs
    // Walk up to find the wrapper, then get the next sibling
    const shopifySection = hero.closest('.shopify-section') || hero;
    const nextSection = shopifySection.nextElementSibling;

    if (nextSection) {
        window.scrollTo({
            top: nextSection.offsetTop,
            behavior: 'smooth'
        });
    }
}

// Make functions globally available
window.scrollToComparison = scrollToComparison;
window.scrollToNext = scrollToNext;

// === VIDEO OPACITY HELPER ===
// Allow runtime opacity adjustment
function setVideoOpacity(videoElement, opacity) {
    if (videoElement) {
        videoElement.style.setProperty('--video-opacity', opacity);
    }
}

// Make function globally available
window.setVideoOpacity = setVideoOpacity;

// === FAQ ACCORDION ===
const faqItems = document.querySelectorAll('.faq-item');
const faqQuestions = document.querySelectorAll('.faq-question');

// Add scroll animation observers for FAQ elements
const faqHeaderBadge = document.querySelector('.faq-header .section-badge');
const faqHeaderTitle = document.querySelector('.faq-header .section-title');

if (faqHeaderBadge) animationObserver.observe(faqHeaderBadge);
if (faqHeaderTitle) animationObserver.observe(faqHeaderTitle);

// Stagger FAQ items animation
faqItems.forEach((item, index) => {
    item.style.transitionDelay = `${index * 0.1}s`;
    animationObserver.observe(item);
});

// === HOW IT WORKS SECTION ANIMATIONS ===
const howHeaderBadge = document.querySelector('.how-header .section-badge');
const howHeaderTitle = document.querySelector('.how-header .section-title');
if (howHeaderBadge) animationObserver.observe(howHeaderBadge);
if (howHeaderTitle) animationObserver.observe(howHeaderTitle);

const howSteps = document.querySelectorAll('.how-step');
howSteps.forEach((step, index) => {
    step.style.transitionDelay = `${index * 0.2}s`;
    animationObserver.observe(step);
});

// FAQ accordion functionality
faqQuestions.forEach((question) => {
    question.addEventListener('click', () => {
        const faqItem = question.closest('.faq-item');
        const isActive = faqItem.classList.contains('active');

        // Close all other FAQ items
        faqItems.forEach(item => {
            if (item !== faqItem) {
                item.classList.remove('active');
            }
        });

        // Toggle current item
        if (isActive) {
            faqItem.classList.remove('active');
        } else {
            faqItem.classList.add('active');
        }
    });
});

console.log('🎬 Sensilight ICE V3 - Refined cinematic experience loaded successfully!');

